import { MaximizeIcon } from 'lucide-preact';
import { ComponentProps } from 'preact/compat';

import { cn } from '@/lib/utils';

const ExpandButton = ({ className, ...rest }: Omit<ComponentProps<'button'>, 'children'>) => (
  <button
    type="button"
    className={cn(
      'preflight preflight-button text-2xl leading-none text-white drop-shadow-lg transition-opacity hover:text-grey-5',
      'desktop:absolute desktop:bottom-0 desktop:left-0 desktop:p-2 desktop:text-base desktop:opacity-0 desktop:group-hover/home-player:opacity-100',
      className,
    )}
    title="Swap mini player content"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  >
    <MaximizeIcon size="1em" />
    <span className="sr-only">Swap mini player content</span>
  </button>
);

export default ExpandButton;
